import React, { useEffect, useState } from "react";
import { FaEye, FaVideo, FaArrowLeft, FaCalendarAlt, FaClock, FaVideoSlash } from "react-icons/fa";
import { getMyMeetingsApi } from "../../services/api";
import "./MeetingsPage.css";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const MeetingsPage = () => {
  const [meetings, setMeetings] = useState([]);
  const [selectedMeeting, setSelectedMeeting] = useState(null);
  const [roleCode, setRoleCode] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    loadMeetings();
  }, []);



  const loadMeetings = async () => {
    try {
      const res = await getMyMeetingsApi();
      setMeetings(res.data.data || []);
      setRoleCode(String(res.data.roleCode || ""));
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="bmaMeetingsWrapper">
      <div className="bmaMeetingsHeader">
        <h1>My Meetings</h1>
        <div className="bmaHeaderLine"></div>
      </div>

      {/* LIST VIEW */}
      {!selectedMeeting && (
        <div className="meetingListWrapper">
          <table className="meetingTable">
            <thead>
              <tr>
                <th>Project</th>
                <th>Role</th>
                <th>Application ID</th>
                <th>Meeting Type</th>
                <th>Date</th>
                <th>Time</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {meetings.length > 0 ? (
                meetings.map((meeting) => (
                  <tr key={meeting.id}>
                    <td>{meeting.role?.project?.project_name}</td>
                    <td>{meeting.role?.role_name}</td>
                    <td>{meeting.application_id}</td>
                    <td>{meeting.booking_type?.replaceAll("_", " ")}</td>
                    <td>
                      {new Date(meeting.meeting_start).toLocaleDateString("en-IN", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric"
                      })}
                    </td>
                    <td>
                      {new Date(meeting.meeting_start).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })}
                      {" - "}
                      {new Date(meeting.meeting_end).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })}
                    </td>
                    <td>
                      <span className={`meetingStatus ${meeting.meeting_status === "EXPIRED" ? "expiredStatus" : "bookedStatus"}`}>
                        {meeting.meeting_status}
                      </span>
                    </td>
                    <td>
                      <div className="meetingActionBtns">
                        <button
                          className="viewBtn"
                          title="View Meeting"
                          onClick={() => {
                            if (roleCode === "300") {
                              const roleId = meeting.role?.id;
                              const slug = meeting.role?.urlSlug || meeting.role?.role_name?.toLowerCase()?.replace(/[–—]/g, "-")?.replace(/\s+/g, "-");
                              navigate(`/audition/${roleId}/${slug}`);
                              return;
                            }
                            if (roleCode === "200" || roleCode === "400") {
                              navigate(`/dashboard/manage-applications/${meeting.joget_audition_id}`);
                              return;
                            }
                          }}
                        >
                          <FaEye />
                        </button>
                        <button
                          className={`joinBtnIcon ${meeting.meeting_status === "EXPIRED" ? "disabledBtn" : ""}`}
                          disabled={meeting.meeting_status === "EXPIRED"}
                          title="Join Meeting"
                         

                          onClick={async () => {
                          if (meeting.meeting_status === "EXPIRED") {
                            Swal.fire({
                              icon: "error",
                              title: "Meeting Expired",
                              text: "This meeting has already expired.",
                            });
                            return;
                          }

                          const result = await Swal.fire({
                            title: "Join Meeting?",
                            text: `Application ID: ${meeting.application_id}`,
                            icon: "",
                            showCancelButton: true,
                            confirmButtonText: "Yes, Join",
                            cancelButtonText: "Cancel",
                            confirmButtonColor: "#28a745",
                            cancelButtonColor: "#dc3545",
                          });

                          if (result.isConfirmed) {
                            window.open(
                              `/meeting/audition-${meeting.application_id}`,
                              "_blank"
                            );
                          }
                        }}
                        >
                          <FaVideo />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" style={{ textAlign: "center" }}>No Meetings Found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* CARD VIEW */}
      {selectedMeeting && (
        <>
          <button className="backBtn" onClick={() => setSelectedMeeting(null)}>
            <FaArrowLeft />
            <span>Back To List</span>
          </button>

          <div className="bmaMeetingGrid">
            <div className="bmaMeetingCard">
              <div className="bmaMeetingPoster">
                <img src={selectedMeeting.role?.project?.project_image || "/no-image.jpg"} alt="project" />
                <div className="bmaMeetingBadge">BOOKED</div>
              </div>

              <div className="bmaMeetingDetails">
                <h2 className="bmaProjectTitle">{selectedMeeting.role?.project?.project_name}</h2>
                <div className="bmaRoleTag">{selectedMeeting.role?.role_name}</div>
                <div className="bmaInfoItem">
                  <span>Application ID</span>
                  <h4>{selectedMeeting.application_id}</h4>
                </div>
                <div className="bmaInfoItem">
                  <span>Meeting Type</span>
                  <h4>{selectedMeeting.booking_type?.replaceAll("_", " ")}</h4>
                </div>
                <div className="bmaStatus">● {selectedMeeting.payment_status}</div>
              </div>

              <div className="bmaMeetingTime">
                <div className="bmaTimeBox">
                  <div className="bmaIconCircle"><FaCalendarAlt /></div>
                  <div>
                    <small>Date</small>
                    <h3>
                      {new Date(selectedMeeting.meeting_start).toLocaleDateString("en-IN", {
                        day: "2-digit", month: "short", year: "numeric"
                      })}
                    </h3>
                  </div>
                </div>

                <div className="bmaTimeBox">
                  <div className="bmaIconCircle"><FaClock /></div>
                  <div>
                    <small>Time</small>
                    <h3>{new Date(selectedMeeting.meeting_start).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })}</h3>
                    <div className="bmaToText">TO</div>
                    <h3>{new Date(selectedMeeting.meeting_end).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })}</h3>
                  </div>
                </div>
              </div>

              <div className="bmaMeetingAction">
                <div className="bmaMeetingCamera"><FaVideoSlash /></div>
                <h3>Meeting Room</h3>
                <p>BookMyAudition Live Meeting</p>
                {selectedMeeting.meeting_status === "EXPIRED" ? (
                  <button className="bmaJoinBtn" disabled>Meeting Expired</button>
                ) : (
                  <a href={selectedMeeting.meeting_link} target="_blank" rel="noreferrer" className="bmaJoinBtn">Join Meeting</a>
                )}
                <div className="bmaRoomBox">{selectedMeeting.meeting_room}</div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default MeetingsPage;